export default __webpack_public_path__ + "static/media/single-project-page-01-img20.580f742e.jpg";